import useSWR from "swr";
import useSWRImmutable from "swr/immutable";
import useSWRMutation from "swr/mutation";

/**
 *
 * @param {import("swr/mutation").SWRMutationResponse | import("swr").SWRResponse } result
 * @returns
 */
function queryDecorator(result) {
  if (Array.isArray(result?.data)) {
    return {
      mutate: result.mutate,
      data: result.data.map(d => d?.data),
      status: result.data.map(d => d?.status),
      isError: result.data.some(d => d?.error !== undefined),
      isLoading: result.data.every(
        d => d?.error === undefined && d?.data === undefined
      ),
      error: result.data.find(d => d?.error !== undefined),
      isMutating: result.data.some(d => d?.isMutating)
    };
  }

  return {
    mutate: result.mutate,
    data: result.data?.data,
    status: result.data?.status || result.error?.response?.status,
    isError: result.error !== undefined,
    isLoading: result.error === undefined && result.data === undefined,
    error: result.error,
    trigger: result.trigger,
    isMutating: result.isMutating
  };
}

export default function (key, fetcher, options) {
  return queryDecorator(useSWR(key, fetcher, options));
}

export function useSWRImmut(key, fetcher) {
  return queryDecorator(useSWRImmutable(key, fetcher));
}

export function useSWRMutate(key, fetcher, options) {
  return queryDecorator(useSWRMutation(key, fetcher, options));
}
